import { extendObservable } from 'mobx'
import { configurationApi } from '@atheneum/api'

class ContractualDetailsStore {
  constructor () {
    extendObservable(this, {
      contractualDetails: null,
      loading: false,
      error: null
    })
  }

  get = () => {
    this.loading = true

    return configurationApi.getAll()
      .then(conf => {
        this.contractualDetails = conf.find(
          ({ key }) => key === 'CONTRACT_CONDITIONS'
        )
        this.loading = false
        this.error = null
      })
      .catch(err => {
        this.error = err
        this.loading = false
      })
  }

  update = data => configurationApi.updateContractualDetails(data)
}

export default ContractualDetailsStore
